// Traduções do rodapé - Português (Brasil)
export const footerPt = {
  titles: {
    links: 'Links',
    contact: 'Contato',
  },
  links: {
    vehicles: 'Veículos',
    about: 'Quem somos',
    contact: 'Contato',
  },
  rights: 'Todos os direitos reservados.',
};
